<template>
  <div :class="['case-card', attributes['imported or local']]">
    <div class="img-container">
      <div :class="['st-svg', this.attributes.condition]" ref="img"></div>
    </div>
    <div class="content">
      <h4>Case {{(+attributes['case-number']).toLocaleString()}}</h4>
      <div v-if="attributes['date-confirmed']">Confirmed on <span class="highlight">{{formatDate(attributes['date-confirmed'])}}</span></div>
      <div v-if="attributes['cluster-group']">Cluster: <span class="highlight">{{attributes['cluster-group']}}</span></div>
      <div v-if="attributes.condition">Status: <div :class="['status', attributes.condition]">{{attributes.condition}}</div></div>
      <ul>
        <li v-if="attributes.age || attributes.gender">{{attributes.agetext}} {{attributes.person}}</li>
        <li v-if="attributes.nationality || attributes['travel-history']">{{attributes.nationality}} {{attributes['travel-history']}}</li>
        <!-- <li v-if="attributes.description" v-markdown="attributes.description"></li> -->
        <li v-if="attributes['bullet-point-1']" v-markdown="attributes['bullet-point-1']"></li>
        <li v-if="attributes['bullet-point-2']" v-markdown="attributes['bullet-point-2']"></li>
        <li v-if="attributes['bullet-point-3']" v-markdown="attributes['bullet-point-3']"></li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  inject: {
    ready: 'iconTemplateReady'
  },
  props: ['attributes'],
  computed: {
    iconType () {
      if (this.attributes.person === 'boy' || this.attributes.person === 'girl') {
        return this.attributes.person
      }
      if (this.attributes.age <= 2) return 'baby'
      if (this.attributes.age >= 65) {
        return this.attributes.gender === 'female' ? 'womansenior' : 'mansenior'
      } else {
        return this.attributes.gender === 'female' ? 'woman' : 'man'
      }
    }
  },
  mounted () {
    this.ready[this.iconType].then($svg => {
      const $clone = $svg.cloneNode(true)
      this.$refs.img.appendChild($clone)
    })
  },
  methods: {
    formatDate (datestr) {
      if (!datestr) return 'NO DATE PROVIDED'
      const lastdate = new Date(datestr)
      var month = lastdate.toLocaleDateString('en-US', {month: 'short'})
      if (lastdate.getMonth() > 1 && lastdate.getMonth() < 7) {
        month = lastdate.toLocaleDateString('en-US', {month: 'long'})
      } else if (month === 'Sep') {
        month = 'Sept'
      }
      const dateformat = `${month} ${lastdate.getDate()}`
      return dateformat
    }
  }
}
</script>

<style lang="scss">
.cases .case-card {
  width: 95%;
  border: 1px solid #e8e8e8;
  border-radius: 3px;
  overflow: hidden;
  background-color: #F0F0F0;
  padding: 10px;
  height: 90%;
  .img-container {
    bottom: -18px;
    text-align: center;
    position: relative;
    display: inline-block;
    width: 40%;
    height: 100%;
    /* width: 60px; */
    @include breakpoint($d_small) {
      /* width: 90px; */
      bottom: -10px;
    }
    img {
      /* width: 60px; */
      height: 100%;
      vertical-align: middle;
      @include breakpoint($d_small) {
        /* width: 90px; */
      }
    }
  }
  .content {
    /* max-width: 195px; */
    width: 60%;
    display: inline-block;
    vertical-align: top;
    padding: 5px 0;
    line-height: 1.3;
    font-size: 15px;
    @include breakpoint($d_small) {
      /* max-width: 250px; */
    }
    h4 {
      padding-bottom: 5px;
    }
    .highlight {
      font-family: $font-CuratorBold;
    }
    .status {
      display: inline-block;
      font-family: $font-CuratorBold;
      &:first-letter {
        text-transform: capitalize
      }
      &.recovered {
        color: #02C7BF;
      }
      &.died {
        /* color: #952370; */
        color: #333;
      }
    }
    ul {
      margin-left: 20px;
      padding-top: 10px;
      li {
        list-style-type: disc;

      }
    }
  }
  .st-svg svg {
    width: 100% !important;
    g, path {
      fill: #878888;
    }
  }

  &.imported {
    .st-svg svg {
      g, path {
        fill: #B8B8B8;
      }
    }
    .st-svg.recovered svg {
      g, path {
        fill: #02C7BF;
      }
    }
    .st-svg.died svg {
      g, path {
        /* fill: #952370; */
        fill: #333;
      }
    }
  }
  &.local {
    .st-svg svg {
      g, path {
        fill: #78838A;
      }
    }
    .st-svg.recovered svg {
      g, path {
        fill: #02C7BF;
      }
    }
    .st-svg.died svg {
      g, path {
        /* fill: #952370; */
        fill: #333;
      }
    }
  }
}
</style>
